var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React from 'react';













const Button = ({
  children,
  styling = 'solid',
  color = 'primary',
  type = 'button',
  size,
  disabled,
  form,
  onClick,
  className = ''
}) => {
  let classNames;
  const textStyles = size === 'medium' ? 'text-sm px-5 py-2.5' : 'text-xs px-3 py-2';

  let bgColor;
  let bgDisabled;
  let border;
  let borderHover;
  let text;
  let textDisabled;
  let textHover;
  let borderDisabled;
  let bgHover;
  switch (color) {
    case 'error':
      bgColor = 'bg-error-700';
      bgHover = 'enabled:hover:bg-error-800';
      bgDisabled = ' disabled:bg-error-300';
      border = 'border-error-700';
      borderHover = 'enabled:hover:border-error-800';
      borderDisabled = 'disabled:border-error-300';
      text = 'text-error-700';
      textDisabled = 'disabled:text-error-300';
      textHover = 'enabled:hover:text-error-700';
      break;

    case 'success':
      bgColor = 'bg-success-700';
      bgHover = 'enabled:hover:bg-success-700';
      bgDisabled = ' disabled:bg-success-300';
      border = 'border-success-700';
      borderHover = 'enabled:hover:border-success-800';
      borderDisabled = 'disabled:border-success-300';
      text = 'text-success-700';
      textDisabled = 'disabled:text-success-300';
      textHover = 'enabled:hover:text-success-700';
      break;

    default:
      bgColor = 'bg-primary-700';
      bgHover = 'enabled:hover:bg-primary-800';
      bgDisabled = ' disabled:bg-primary-300';
      border = 'border-primary-700';
      borderHover = 'enabled:hover:border-primary-800';
      borderDisabled = 'disabled:border-primary-300';
      text = 'text-primary-700';
      textDisabled = 'disabled:text-primary-300';
      textHover = 'enabled:hover:text-primary-700';
      break;
  }

  switch (styling) {
    case 'outline':
      classNames = `bg-white enabled:hover:text-white ${text} ${border} ${textDisabled} ${borderDisabled} ${bgHover} ${borderHover}`;
      break;
    case 'light':
      classNames = `text-gray-700 disabled:text-gray-300 bg-white border-gray-200 ${textHover}`;
      break;

    default:
      classNames = `text-white ${bgColor} ${border} ${bgDisabled} ${borderDisabled} ${bgHover} ${borderHover}`;
      break;
  }

  return /*#__PURE__*/(
    _jsx("button", {
      type: type === 'submit' ? 'submit' : 'button',
      onClick: onClick,
      disabled: disabled,
      className: `${classNames} ${textStyles} disabled:cursor-not-allowed font-medium rounded-lg
      border focus:outline-none focus:ring-4 focus:ring-indigo-200 ${className}`,
      form: form }, void 0,

    children
    ));

};

export { Button };